import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { NumericFormat } from "react-number-format";

const ModalVoucher = ({
  isOpen,
  toggle,
  formData,
  handleChange: originalHandleChange,
  handleSubmit,
  loading,
  campanhas,
  parceiros,
}) => {
  // Wrapper para o handleChange que trata o campo codigo
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "codigo") {
      // Remove acentos e caracteres especiais, converte para maiúsculas
      const formattedValue = value
        .toUpperCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // Remove acentos
        .replace(/[^A-Z0-9_]/g, ""); // Permite apenas letras, números e underscore

      originalHandleChange({
        target: { name, value: formattedValue },
      });
    } else {
      originalHandleChange(e);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          <span className="fw-semibold">Criar Voucher</span>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <FormGroup>
                <Label for="campanha_id" className="fw-medium">
                  Campanha <span className="text-danger">*</span>
                </Label>
                <Input
                  id="campanha_id"
                  name="campanha_id"
                  type="select"
                  value={formData.campanha_id}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione uma campanha</option>
                  {campanhas.map((campanha) => (
                    <option key={campanha.id} value={campanha.id}>
                      {campanha.nome}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>

            <div className="col-md-6">
              <FormGroup>
                <Label for="tipo" className="fw-medium">
                  Tipo de Voucher <span className="text-danger">*</span>
                </Label>
                <Input
                  id="tipo"
                  name="tipo"
                  type="select"
                  value={formData.tipo}
                  onChange={handleChange}
                  required
                >
                  <option value="fixo">Código Fixo</option>
                  <option value="aleatorio">Código Aleatório</option>
                </Input>
              </FormGroup>
            </div>

            <div className="col-md-6">
              <FormGroup>
                <Label for="parceiro_id" className="fw-medium">
                  Parceiro
                </Label>
                <Input
                  id="parceiro_id"
                  name="parceiro_id"
                  type="select"
                  value={formData.parceiro_id}
                  onChange={handleChange}
                >
                  <option value="">Selecione um parceiro</option>
                  {parceiros.map((parceiro) => (
                    <option key={parceiro.id} value={parceiro.id}>
                      {parceiro.nome}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>

            {formData.tipo === "fixo" && (
              <div className="col-md-12">
                <FormGroup>
                  <Label for="codigo" className="fw-medium">
                    Código do Voucher <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="codigo"
                    name="codigo"
                    type="text"
                    value={formData.codigo}
                    onChange={handleChange}
                    required={formData.tipo === "fixo"}
                    placeholder="Ex: BLACKFRIDAY2024"
                    maxLength={20}
                  />
                </FormGroup>
              </div>
            )}

            <div className="col-md-6">
              <FormGroup>
                <Label for="valor" className="fw-medium">
                  Valor <span className="text-danger">*</span>
                </Label>
                <NumericFormat
                  className="form-control"
                  id="valor"
                  name="valor"
                  placeholder="R$ 0,00"
                  value={formData.valor}
                  onValueChange={({ value }) =>
                    handleChange({
                      target: {
                        name: "valor",
                        value: parseFloat(value),
                      },
                    })
                  }
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  prefix="R$ "
                  allowNegative={false}
                />
              </FormGroup>
            </div>

            <div className="col-md-6">
              <FormGroup>
                <Label for="quantidade" className="fw-medium">
                  Quantidade <span className="text-danger">*</span>
                </Label>
                <Input
                  id="quantidade"
                  name="quantidade"
                  type="number"
                  value={formData.quantidade}
                  onChange={handleChange}
                  required
                  min="1"
                  placeholder="Ex: 100"
                />
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="light"
            onClick={toggle}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            color="info"
            className="ms-2"
            disabled={loading}
          >
            {loading && <Spinner size="sm" className="me-2" />}
            Criar Voucher
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ModalVoucher;
